export function initHeaderFixed(){
    const header = document.querySelector<HTMLElement>('header');
    if (!header) return;

    let ticking = false;

    const updateHeader = () => {
        if (window.scrollY > 20) {
            header.classList.add('fixed');
        } else {
            header.classList.remove('fixed');
        }
        ticking = false;
    };

    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(updateHeader);
            ticking = true;
        }
    });
}